// La card de un DESTINO (Redes sociales, Catálogos, Anuncios) en el teléfono
// (ADR-2026-10-08-la-interfaz-nueva-llega-al-telefono). La usan la home mobile de la
// interfaz nueva y el primer paso del sheet de destinos, así las dos se ven igual.
//
// Mismo contenido que la card cuadrada de escritorio (`CabeceraPorDestino`): tinte, los
// formatos en una pastilla arriba del título
// (ADR-2026-10-14-los-formatos-de-la-card-van-en-una-pastilla), título, bajada con
// verbo y el abanico de resultados. Cambia la forma: en una
// columna de 360px tres cuadrados serían tres pantallas, así que va APAISADA —el texto a la
// izquierda y dos fichas del abanico a la derecha, como las herramientas de Photoroom—.

import {
  AbanicoDeResultados,
  plataformasDe,
  SECCIONES,
  FormatosDeLaCard,
  type Seccion,
} from '../../estilos/CabeceraPorDestino';
import { rubroMarcaCacheado } from '../../../hooks/useRubroMarca';

export function CardDestinoMobile({
  seccion,
  onClick,
  unidadAbanico = '0.75px',
  abanicoAfuera = 34,
  rubro = rubroMarcaCacheado(),
}: {
  seccion: Seccion;
  onClick: () => void;
  /** El rubro de la marca: elige las fotos del abanico (Belleza ve productos de belleza,
   *  ADR-2026-10-12-el-abanico-de-belleza). Sin pasarlo, el último que se cacheó. */
  rubro?: string | null;
  /** La escala del abanico. El carrusel de la home lo pone en 0.72: ahí la card es más
   *  angosta que la pantalla (ADR-2026-10-12-los-destinos-en-carrusel-en-el-telefono). */
  unidadAbanico?: string;
  /** Cuántos px se sale el abanico por la derecha. El carrusel lo corre hasta que el borde
   *  corta la segunda foto por la mitad: se sigue entendiendo y las fotos pueden ser más
   *  grandes (ADR-2026-10-12-las-fotos-del-carrusel-se-cortan-en-el-borde). */
  abanicoAfuera?: number;
}) {
  const copy = SECCIONES[seccion];
  const proximamente = !!copy.proximamente;
  return (
    <button
      type="button"
      onClick={proximamente ? undefined : onClick}
      disabled={proximamente}
      className={`relative flex min-h-[148px] w-full items-center overflow-hidden rounded-[20px] border border-black/[0.06] p-4 text-left active:scale-[0.99] transition-transform disabled:active:scale-100 ${copy.tinte}`}
    >
      {/* Los formatos, SIEMPRE arriba a la izquierda, con el mismo aire que el borde de la card:
          dentro de la columna de texto (que se centra en alto) subían o bajaban según el largo
          del título y la bajada (ADR-2026-10-14-los-formatos-de-la-card-van-en-una-pastilla-3). */}
      <span className="absolute left-4 top-4 z-10">
        <FormatosDeLaCard formatos={copy.formatos} seccion={seccion} chica />
      </span>
      {/* El texto se queda con la mitad izquierda larga; el abanico, con la derecha. Arriba
          deja el lugar de los formatos (24px) y su aire. */}
      <span className="relative z-10 flex w-[56%] flex-col pt-9">
        <span className="text-[18px] font-bold leading-tight tracking-[-0.02em] text-[#16181D]">
          {copy.titulo}
        </span>
        <span className="mt-1 text-[12.5px] leading-snug text-black/55">{copy.bajada}</span>
        {proximamente && (
          <span className="mt-2.5 inline-flex w-fit items-center rounded-full bg-white px-2.5 py-0.5 text-[11.5px] font-bold text-[#16181D]">
            Próximamente
          </span>
        )}
      </span>
      {/* Dos fichas (las del frente) a escala 0.75: con tres, la de atrás caía debajo del
          texto. */}
      {/* La caja del abanico es más ancha que sus dos fichas (deja lugar para la tercera):
          corrida 34px afuera, las fichas caen pegadas al borde derecho sin pisar el texto. */}
      <span className="pointer-events-none absolute top-1/2 -translate-y-1/2" style={{ right: -abanicoAfuera }}>
        <AbanicoDeResultados plataformas={plataformasDe(seccion, rubro)} cantidad={2} unidad={unidadAbanico} />
      </span>
    </button>
  );
}
